<template>
    <div>

        <a-skeleton v-if="loadingPage" active />

        <a-card v-else :bordered="false" class="header-solid h-full mb-40" :bodyStyle="{ paddingTop: '12px' }">

            <template #title>
                <div v-if="Object.keys(dataPeriods).length == 0">
                    <a-alert message="Registration Not Available"
                        description="Parking registration is not available at this time. Please wait until the registration period opens."
                        type="warning" />
                </div>
                <div v-else>
                    <a-row>
                        <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                            <a-space size="large" align="center">
                                <a-avatar slot="avatar" :size="70" src="images/icon_parking.png" />
                                <span>

                                    <h4 class="mt-0 mb-0">
                                        Parking Fees at Aditayathorn Building ({{ dataPeriods.semester }} / {{
                                            dataPeriods.academic_year }})
                                    </h4>
                                    <p class="font-web mt-0 mb-0">Parking fee on Floors B3-B2 will be {{
                                        Number(dataPeriods.price).toLocaleString() }} THB per trimester covering the
                                        period
                                        <span class="text-success">{{ moment(dataPeriods.parking_start_date).format('DD / MMMM / YYYY HH: mm: ss') }}</span> until fully booked
                                    </p>
                                    <p class="font-web mt-0 mb-0">
                                        <i style="">
                                            The number of parking lots is limited. Contact Aditayathorn Building Group
                                            at Telephone: +66 (0) 2700 5000 Ext.No.4304,4307
                                        </i>
                                    </p>
                                </span>
                            </a-space>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                        </a-col>
                    </a-row>
                </div>
            </template>
            <span v-if="Object.keys(dataPeriods).length != 0">
                <a-row class="mt-30 mb-15" gutter="24">
                    <a-col style="border: 10px" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                        <a-card :bordered="false" class="header-solid h-full mb-40" :bodyStyle="{ paddingTop: '12px' }">
                            <a-card-meta>
                                <div slot="title">
                                    <p class="font-web mt-0 mb-0"><i>STEP 1</i> </p>
                                    <h5 style="color: #640D5F;" class="font-web mt-0 mb-0">ONLINE REGISTER</h5>
                                </div>
                                <div slot="description">
                                    <p class="font-web mt-0 mb-0">
                                        Registration begins {{ moment(dataPeriods.register_start_date).format('MMMM DD, YYYY') }} at {{ moment(dataPeriods.register_start_date).format('HH:mm') }}
                                    </p>
                                    <p class="font-web mt-0 mb-0"> until fully booked </p>
                                </div>
                                <a-avatar slot="avatar" :size="70" src="images/icon_parking_regis.png" />
                            </a-card-meta>
                        </a-card>
                    </a-col>
                    <a-col :style="{ border: 12 }" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                        <a-card :bordered="false" class="header-solid h-full mb-40" :bodyStyle="{ paddingTop: '12px' }">
                            <a-card-meta>
                                <div slot="title">
                                    <p class="font-web mt-0 mb-0"><i>STEP 2</i> </p>
                                    <h5 style="color: #640D5F;" class="font-web mt-0 mb-0">PAYMENT Via QR code</h5>
                                </div>
                                <div slot="description">
                                    <p class="font-web mt-0 mb-0">
                                        Payment begins {{ moment(dataPeriods.payment_start_date).format('MMMM DD, YYYY') }} at {{ moment(dataPeriods.payment_start_date).format('HH:mm') }}
                                    </p>
                                    <p class="font-web mt-0 mb-0"> until fully booked </p>
                                </div>
                                <a-avatar slot="avatar" shape="square" :size="70" src="images/thaiQrPay.png" />
                            </a-card-meta>
                        </a-card>
                    </a-col>
                    <a-col :style="{ border: 12 }" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                        <a-card :bordered="false" class="header-solid h-full mb-40" :bodyStyle="{ paddingTop: '12px' }">
                            <a-card-meta>
                                <div slot="title">
                                    <p class="font-web mt-0 mb-0"><i>STEP 3</i> </p>
                                    <h5 style="color: #640D5F;" class="font-web mt-0 mb-0">Activate Student card for
                                        Access Parking
                                    </h5>
                                </div>
                                <div slot="description">
                                    <p class="font-web mt-0 mb-0">
                                        {{ moment(dataPeriods.activate_start_date).format('MMMM DD') }} - {{ moment(dataPeriods.activate_end_date).format('MMMM DD, YYYY') }} onwards.
                                    </p>
                                    <p class="font-web mt-0 mb-0">
                                        At Room No. B114, B1 Floor, Aditayathorn Building
                                    </p>
                                </div>
                                <a-avatar slot="avatar" :size="70" src="images/icon_parking_stricker.png" />
                            </a-card-meta>
                        </a-card>
                    </a-col>
                </a-row>

                <!-- buy ticket -->
                <div v-if="checkQuota" class="mt-10 mb-10 text-center">
                    <a-button v-if="dataPeriods.is_active" @click="openBuyStickerModal" type="primary" size="large">
                        <a-icon type="schedule" /> Buy Parking Rights (Student ID card)
                    </a-button>
                    <a-button v-else disabled size="large">
                        <a-icon type="schedule" /> Buy Parking Rights (Student ID card)
                    </a-button>
                </div>
                <div class="text-center" v-else>

                    <div v-if="['PAID', 'READY_FOR_PARKING'].includes(dataBillList[0].status)">
                        <a-alert v-if="Object.keys(dataPeriods).length != 0" message="PARKING REGISTRATION ANNOUNCEMENT"
                            type="success" show-icon>
                            <div slot="description">
                                <h5 class="font-web mt-0 mb-0 font-weight-bold">
                                    You have successfully completed the parking payment
                                    for the Parking Lot Registration
                                    (Trimester {{ dataPeriods.semester }} / {{ dataPeriods.academic_year }}).
                                </h5>
                                <p class="mt-5 mb-0 text-success font-web">
                                    Your payment has been recorded. No further action is required at this time.
                                </p>
                            </div>
                        </a-alert>
                    </div>

                </div>

                <!-- tab data -->
                <div class="mt-30 mb-20">
                    <a-tabs type="card" @change="callback">
                        <a-tab-pane key="3">
                            <span slot="tab">
                                <a-icon style="font-size: 18px;" type="car" theme="twoTone" />
                                <span style="font-size: 18px; font-weight: 500;" class="mt-0 mb-0 font-web">Setting My
                                    Cars</span>
                            </span>
                            <div class="mt-10 mb-10">
                                <formsettingcar :formCar="formCar" :dataCar="dataCar" @addDataCar="addDataCar" />
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="2">
                            <span slot="tab">
                                <a-icon style="font-size: 18px;" type="reconciliation" theme="twoTone" />
                                <span style="font-size: 18px; font-weight: 500;" class="mt-0 mb-0 font-web">Bill
                                    Payment</span>
                            </span>
                            <div class="mt-10 mb-10">
                                <billpay :dataBillList="dataBillList" />
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="1" style="padding: 20px;">
                            <span slot="tab">
                                <a-icon style="font-size: 18px;" type="schedule" theme="twoTone" />
                                <span style="font-size: 18px; font-weight: 500;" class="mt-0 mb-0 font-web">Your
                                    Stricker</span>
                            </span>
                            <div class="mt-10 mb-10">
                                <strickerlist :datacaractive="datacaractive" />
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </span>

        </a-card>

        <!-- term condition modal -->
        <a-modal width="700px" v-model="modalTermCondition">
            <template slot="title">
                <h6 class="mt-5 mb-5 font-web text-danger"><a-icon class="mr-10" type="exception" />Terms and
                    conditions.</h6>
            </template>
            <template slot="footer">
                <a-button key="submit" type="primary" @click="() => { modalTermCondition = false }">
                    I accept the terms and condition.
                </a-button>
            </template>
            <p class="mt-0 mb-15 font-web">1.In the event of any damage, the holder of the parking rights shall be fully
                responsible for all resulting damages.</p>
            <p class="mt-0 mb-15 font-web">2.For safety and security, the parking system will record images of drivers
                at entry
                and exit points.</p>
            <p class="mt-0 mb-15 font-web">3. Registration of parking reservation is considered complete only after
                payment of
                parking fee.</p>
            <p class="mt-0 mb-15 font-web">4. The parking fee is non-refundable.</p>
            <p class="mt-0 mb-15 font-web">5. Resale of MUIC Parking Rights (Student ID card) is not allowed. Parking
                Rights
                (Student ID card) should not
                be given
                to another person.</p>
            <p class="mt-0 mb-15 font-web">6. If, upon inspection of your Parking Rights (Student ID card) by the
                Security and
                Traffic Office, it is discovered that the driver's name and student
                ID do not match the registered information, you will receive a
                warning letter and the suspension of your car park permit will be
                considered.</p>
            <p class="mt-0 mb-15 font-web">7. Violation of the regulations shall result in a warning letter from
                the Security and Traffic Office. Two warning letters will result in
                disqualification from parking registration in the following
                semester.</p>

            <p class="mt-0 mb-15 font-web">8. Aditayathorn parking is provided for your convenience. MUIC will not
                be responsible for theft or damage to vehicles or vehicle contents
                in Aditayathorn Parking.</p>
            <p class="mt-0 mb-15 font-web">9. We reserve the right to provide parking lots during MUIC events (such as
                Open
                Days, Graduation Ceremony, etc.) on a first-come, first-served basis for everyone (i.e., both those who
                have and
                do not have MUIC Parking Rights (Student ID card) ).</p>
        </a-modal>

        <!-- modal pay -->
        <a-modal width="700px" v-model="modalCarPayStricker">
            <template slot="title">
                <h6 class="mt-5 mb-5 font-web"><a-icon class="mr-10" type="exception" />Pay for the parking reservation.
                </h6>
            </template>
            <template slot="footer">
                <a-button @click="closePopUpPayParking"> Close pop-up process </a-button>
            </template>
            <div class="mt-10 mb-10">
                <formpay />
            </div>
        </a-modal>

        <!-- Buy Sticker Modal -->
        <a-modal width="600px" v-model="modalBuySticker" :maskClosable="false" :footer="null"
            @cancel="closeBuyStickerModal">
            <template slot="title">
                <h6 class="mt-5 mb-5 font-web"><a-icon class="mr-10" type="car" />Buy Parking Rights (Student ID card)
                </h6>
            </template>

            <!-- Step 1: Select Car -->
            <div v-if="paymentStep === 1">


                <div v-if="dataCar.length != 0">
                    <div class="d-flex align-start">
                        <div class="font-web">
                            <h5 class="mt-0 mb-5">Proceed to Payment</h5>

                            <p class="mt-0 mb-5">
                                You are about to proceed to the payment step.
                                Please review the information carefully and ensure that your mobile banking
                                or payment application is ready.
                            </p>

                            <p class="mt-0 mb-5">
                                Once you are ready, please continue to complete the payment.
                            </p>

                            <p class="mt-0 mb-0 payment-expire text-danger">
                                ⚠ The QR code for payment is valid for
                                <strong>10 seconds only</strong>.
                                Please complete the payment within the specified time.
                            </p>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <a-alert message="Vehicle Registration Required"
                        description="You have not registered any vehicle in the system. Please return and add your vehicle information before proceeding."
                        type="error" closable />
                </div>


                <div v-if="errorcreateQr.includes('Not in payment period.')">
                    <a-alert class="mt-10" type="error" show-icon message="Payment Period Closed">
                        <div slot="description">
                            <p class="font-web mt-0 mb-0">This action cannot be completed because the system is
                                currently
                                outside the payment period in</p>
                            <p class="font-web mt-0 mb-0">Start ::
                                {{ moment(dataPeriods.payment_start_date).format('MMMM DD,YYYY HH:mm') }}</p>
                            <p class="font-web mt-0 mb-0">End :: {{ moment(dataPeriods.payment_end_date).format('MMMMDD, YYYYHH: mm') }} </p>
                        </div>
                    </a-alert>
                </div>
                <div v-if="errorcreateQr.includes('Parking quota full.')">
                    <a-alert class="mt-10" type="error" show-icon message="Parking Unavailable"
                        description="The parking quota has been fully allocated. No parking slots are currently available at this time."
                        closable />
                </div>
                <div v-if="errorcreateQr.includes('Other')">
                    <a-alert class="mt-10" type="error" show-icon message="QR Code Generation Failed"
                        description="An issue occurred while generating the QR code. Please contact the support staff using the contact information provided in the official announcement."
                        closable />
                </div>

                <div class="text-right mt-30">
                    <a-button @click="closeBuyStickerModal" class="mr-10">Cancel</a-button>
                    <a-button type="primary" :loading="loadingQr" @click="goToPayment">Next</a-button>
                </div>
            </div>

            <!-- Step 2: Payment -->
            <div v-if="paymentStep === 2" class="text-center">
                <h4 class="mb-20">Scan to Pay</h4>
                <div class="mb-20" v-if="Object.keys(qrCodeUrl).length != 0">
                    <img :src="`data:image/png;base64,${qrCodeUrl.qr_image}`" alt="imag_mainparking_1"
                        style="max-width: 200px; border: 1px solid #eee; padding: 10px;">
                </div>
                <div v-else class="mb-20">
                    <a-skeleton active />
                </div>

                <p class="mt-5 mb-5 font-web">
                    Please scan the QR code to complete the payment.
                </p>
                <p class="mt-5 mb-5 font-web" style="color: #ff4d4f; font-weight: 700;">
                    This QR code is valid for only 10 seconds. Please complete the payment before the time expires.
                </p>

                <a-button type="primary" icon="download" class="mt-10" :disabled="!qrCodeUrl.qr_image"
                    @click="downloadQrImage">
                    Save QR Image
                </a-button>

                <div class="text-center mt-30">

                    <a-button @click="closeBuyStickerModal">Cancel</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import strickerlist from './strickerlist.vue';
import billpay from './billpay.vue';
import formpay from './formpay.vue';
import formsettingcar from './formsettingcar.vue';
import historypay from './historypay.vue';
import moment from 'moment';

const formCar = {
    // "owner":"",
    "license_plate_prefix": "",
    "license_plate_number": "",
    "province": "กรุงเทพมหานคร",
    "model": "",
    "color": "",
    "brand": "",
    "fuel_type": "",
    "remark": "-",
    "contact_number": "",
}

export default {
    components: {
        strickerlist,
        billpay,
        formpay,
        formsettingcar,
        historypay
    },
    data() {
        return {
            // 
            loadingPage: '',
            dataPeriods: {},
            errorMsgPeriods: [],
            // 
            modalTermCondition: false,
            modalCarPayStricker: false,
            loadingBuyParking: false,
            itemBillStd: [],
            formCar: { ...formCar },
            // Buy Sticker Modal Data
            modalBuySticker: false,
            paymentStep: 1,
            selectedCarId: undefined,
            pollingTimer: null,
            pollingInterval: 5000,
            currentBillId: null,
            loadingQr: false,


            paymentCheckCount: 0,
            qrCodeUrl: {},
            // cardetail
            dataCar: [],
            // bill list
            dataBillList: [],
            errorcreateQr: [],
            // car active
            datacaractive: [],
            checkQuota: true,
        }
    },
    async mounted() {
        await this.checkUserRole()
        this.openPopUpTermCondition()
        this.getPeriodsParking()
        this.getCarParking()
        this.getFeeParkingPayment()
    },
    computed: {
        approvedCars() {
            return this.dataCar.filter(car => car.status === 'approved');
        },
        selectedCar() {
            return this.dataCar.find(car => car.id === this.selectedCarId);
        },
        qrImageSrc() {
            return this.qrCodeUrl?.qr_image
                ? `data:image/png;base64,${this.qrCodeUrl.qr_image}`
                : '';
        }
    },
    beforeDestroy() {
        this.stopPolling()
    },
    methods: {
        async checkUserRole() {
            try {
                const response = await this.$http.get('/whoami/');
                if (response && response.data) {
                    const roles = response.data.roles || [];
                    if (!roles.includes('students')) {
                        this.$router.push('/');
                    }
                }
            } catch (e) {
                console.error('Role check error:', e);
                this.$router.push('/');
            }
        },
        downloadQrImage() {
            if (!this.qrCodeUrl.qr_image) return;

            const link = document.createElement('a');
            link.href = `data:image/png;base64,${this.qrCodeUrl.qr_image}`;
            link.download = `parking_qr_${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        openPopUpTermCondition() {
            this.modalTermCondition = true
        },
        callback(key) {
            console.log(key);
        },

        openPopUpPayParking() {
            this.modalCarPayStricker = true
        },
        closePopUpPayParking() {
            this.modalCarPayStricker = false
            this.itemBillStd = []
            this.loadingBuyParking = false
        },
        // period
        async getPeriodsParking() {
            this.loadingPage = true
            this.dataPeriods = [];
            this.errorMsgPeriods = []
            try {
                const res = await this.$http.get("/parking/periods/active/");
                if (res.status === 200) {

                    this.dataPeriods = { ...res.data };

                    try {
                        const resQuota = await this.$http.get(`/parking/periods/${this.dataPeriods.id}/check_quota/`);
                        if (resQuota.status === 200) {
                            // checkQuota
                            this.checkQuota = resQuota.data.is_available
                        } else {
                            const error = new Error('API Error');
                            error.resQuota = resQuota;
                            throw error;
                        }
                    } catch (error) { }

                    this.loadingPage = false
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                console.log(error.response);
                this.errorMsgPeriods.push(error.response)
                this.loadingPage = false
            }
        },
        // car
        async getCarParking() {
            this.dataCar = [];
            try {
                const res = await this.$http.get("/parking/cars/");
                if (res.status === 200) {
                    this.dataCar = res.data
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                console.log(error.response);
            }
        },
        getDefaultFormCar() {
            return {
                license_plate_prefix: "",
                license_plate_number: "",
                province: "กรุงเทพมหานคร",
                model: "",
                color: "",
                brand: "",
                fuel_type: "",
                remark: "-",
                contact_number: "",
            }
        },
        addDataCar(...args) {
            this.dataCar.push(args[0])
            this.formCar = this.getDefaultFormCar()
        },
        // payment data
        parseParkingPaymentResponse(response) {


            if (!response || typeof response !== "object") {
                return {
                    success: false,
                    message: "Invalid response format"
                }
            }

            if (!response.status || response.status.code !== 1000) {
                return {
                    success: false,
                    message: response.status?.description || "Unknown error"
                }
            }

            const data = response.data || {}

            return {
                success: true,

                statusCode: response.status.code,
                statusMessage: response.status.description,

                expiryDate: data.expiryDate,
                numberOfTimes: data.numberOfTimes,

                qrRawData: data.qrRawData,
                qrImageBase64: data.qrImage,
                qrImageSrc: data.qrImage
                    ? `data:image/png;base64,${data.qrImage}`
                    : null,

                ref1: data.ref1 || response.ref_1,
                ref2: data.ref2 || response.ref_2
            }
        },
        async getFeeParkingPayment() {
            this.dataBillList = []
            this.datacaractive = []
            try {
                const res = await this.$http.get("/parking/payments/");
                if (res.status === 200) {


                    this.dataBillList = res.data.map((item, index) => {

                        let parsedRaw = null

                        try {
                            parsedRaw = typeof item.raw_payment_data === "string"
                                ? JSON.parse(item.raw_payment_data)
                                : item.raw_payment_data
                        } catch (e) {
                            console.error("JSON parse error:", e)
                        }

                        return {
                            ...item,
                            dataDeJson: this.parseParkingPaymentResponse(parsedRaw)
                        };
                    });

                    this.datacaractive = res.data.filter((data) => (['PAID', 'READY_FOR_PARKING'].includes(data['status'])) && (data['period_details']['id'] === this.dataPeriods.id)).map((item, index) => {

                        let parsedRawB = null

                        try {
                            parsedRawB = typeof item.raw_payment_data === "string"
                                ? JSON.parse(item.raw_payment_data)
                                : item.raw_payment_data
                        } catch (e) {
                            console.error("JSON parse error:", e)
                        }

                        return {
                            ...item,
                            dataDeJson: this.parseParkingPaymentResponse(parsedRawB)
                        };
                    });

                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.dataBillList = []
                this.datacaractive = []
                console.log(error.response);
            }
        },
        // Buy Sticker Modal Methods
        openBuyStickerModal() {
            this.modalBuySticker = true;
            this.paymentStep = 1;
            this.selectedCarId = undefined;
            this.paymentCheckCount = 0;
        },
        handleCarSelect(value) {
            this.selectedCarId = value;
        },
        async goToPayment() {
            this.loadingQr = true;
            await this.cratePaymentBill()
        },
        async cratePaymentBill() {
            this.errorcreateQr = []
            try {
                const sendformGenPayment = new FormData();
                sendformGenPayment.append("period_id", this.dataPeriods.id);

                const response = await this.$http.post(
                    "/parking/payments/create_qr/",
                    sendformGenPayment,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                if (response.status === 200 || response.status === 201) {
                    this.qrCodeUrl = { ...response.data };
                    console.log("QR Created:", response.data);
                    this.currentBillId = response.data.id
                    this.paymentStep = 2
                    this.startPolling()
                } else {
                    const error = new Error('API Error');
                    error.response = response;
                    throw error;
                }
            } catch (error) {
                if (['400', 400].includes(error.response.status)) {
                    this.errorcreateQr.push(error.response.data.error)
                } else {
                    this.errorcreateQr.push('Other')
                }
                this.loadingQr = false
                return null;
            }
        },
        backToStep1() {
            this.stopPolling();
            this.paymentStep = 1;
            this.qrCodeUrl = {};
            this.currentBillId = null;
        },
        startPolling() {
            if (this.pollingTimer) return

            this.pollingTimer = setInterval(() => {
                this.checkPaymentStatus()
            }, this.pollingInterval)
        },
        async checkPaymentStatus() {
            try {
                const res = await this.$http.get(
                    `/parking/payments/${this.currentBillId}/`
                )
                if (res.status === 200 || res.status === 201) {
                    console.log("Payment status:", res.data.status)

                    if (res.data.status === "PAID") {
                        this.stopPolling()
                        this.loadingQr = false
                        this.closeBuyStickerModal()
                    }

                    if (res.data.status === "EXPIRED") {
                        this.stopPolling()
                        this.loadingQr = false
                    }
                } else {
                    const apiError = new Error('API Error');
                    apiError.res = res;
                    throw apiError;
                }
            } catch (error) {
                console.error("Polling error:", error)
            }
        },
        stopPolling() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
                this.pollingTimer = null
                this.getFeeParkingPayment()
            }
        },
        closeBuyStickerModal() {
            this.stopPolling();
            this.modalBuySticker = false;
            this.paymentStep = 1;
            this.qrCodeUrl = {};
            this.currentBillId = null;
            this.errorcreateQr = []
        },

    }
}
</script>